/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Strip_MarkupInputs */

const en_dialog_text_to_audio_strip_markup = /** @type {(inputs: Dialog_Text_To_Audio_Strip_MarkupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strip markdown and HTML`)
};

const es_dialog_text_to_audio_strip_markup = /** @type {(inputs: Dialog_Text_To_Audio_Strip_MarkupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar markdown y HTML`)
};

/**
* | output |
* | --- |
* | "Strip markdown and HTML" |
*
* @param {Dialog_Text_To_Audio_Strip_MarkupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_strip_markup = /** @type {((inputs?: Dialog_Text_To_Audio_Strip_MarkupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Strip_MarkupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_strip_markup(inputs)
	return en_dialog_text_to_audio_strip_markup(inputs)
});